import React, { useState, useEffect } from 'react';
import './XPProgress.css';
import useIsMobile from '../../hooks/ismobile.js';

function XPProgress({ xpProgress, totalProgress, userLevel }) {
	const metrics = xpProgress;
	console.log('XP Progress Metrics: ', metrics);
	// Track animated widths
	const [animatedWidths, setAnimatedWidths] = useState(metrics.map(() => 0));
	const [animatedTotal, setAnimatedTotal] = useState(0);
	const isMobile = useIsMobile();

	useEffect(() => {
		const timeout = setTimeout(() => {
			setAnimatedWidths(metrics.map((m) => (m.value / m.max) * 100));
			setAnimatedTotal(Math.min(totalProgress * 100, 100));
		}, 200); // delay to trigger animation

		return () => clearTimeout(timeout);
	}, [xpProgress, totalProgress]);

	return (
		<div>
			{!isMobile ? (
				<>
					<h2 className="xp-header"> 🎯 XP Progress - Level {userLevel}</h2>
					{metrics.map((metric, index) => (
						<div key={index} className="xp-row">
							<div className="xp-label">{metric.label}</div>
							<div className="xp-count">
								{metric.value}/{metric.max}
							</div>
							<div className="xp-bar-wrapper">
								<div
									className="xp-bar-fill"
									style={{
										//width: `${(metric.value / metric.max) * 100}%`,
										// backgroundColor: metric.color,
										width: `${animatedWidths[index]}%`,
										background: `linear-gradient(to right, ${metric.gradient[0]}, ${metric.gradient[1]})`,
									}}
								/>
							</div>
						</div>
					))}
					<div className="xp-footer-bar">
						<div
							className="xp-bar-fill"
							style={{
								//width: `${Math.min(levelProgress * 100, 100)}%`,
								//backgroundColor: '#ffd000',
								width: `${animatedTotal}%`,
								background: `linear-gradient(to right, #F98D30, #FFDE05)`,
							}}
						/>
					</div>
				</>
			) : (
				<div>
					<h2 className="xp-header">🎯 XP Progress - Level {userLevel}</h2>
					{metrics.map((metric, index) => (
						<div key={index} className="xp-row-mobile">
							<div className="xp-label-mobile">
								<span>{metric.label}</span>
								<span className="xp-count-mobile">
									{metric.value}/{metric.max}
								</span>
							</div>
							<div className="xp-bar-wrapper-mobile">
								<div
									className="xp-bar-fill-mobile"
									style={{
										width: `${animatedWidths[index]}%`,
										background: `linear-gradient(to right, ${metric.gradient[0]}, ${metric.gradient[1]})`,
									}}
								/>
							</div>
						</div>
					))}
					<div className="xp-footer-bar-mobile">
						<div
							className="xp-bar-fill-mobile"
							style={{
								width: `${animatedTotal}%`,
								background: `linear-gradient(to right, #F98D30, #FFDE05)`,
							}}
						/>
					</div>
				</div>
			)}
		</div>
	);
}

export default XPProgress;
